module.exports = __webpack_public_path__ + "img/img-3mobile.420ba6db.png";